import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ScenarioConsolidationService } from '../../service/scenario-consolidation.service';
import { ScenarioConsolidationActions } from './scenario-consolidation.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { HeatMapResults } from '../../../../graphql/generated';


@Injectable()
export class ScenarioConsolidationEffects {

  loadProcessHeatMap$ = createEffect(
    (rs: ScenarioConsolidationService = inject(ScenarioConsolidationService)) => {
      return this.actions$.pipe(

        ofType(ScenarioConsolidationActions.loadProcessHeatMap),
        mergeMap(({ scenarioId, valueChain }) =>
          rs.getProcessHeatMap(scenarioId, valueChain).pipe(
            map((heatmap) => {
              return ScenarioConsolidationActions.loadProcessHeatMapSuccess({
                processHeatmap: heatmap as HeatMapResults
              });
            }),
            catchError((error) => of(ScenarioConsolidationActions.loadProcessHeatMapFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadRiskHeatMap$ = createEffect(
    (rs: ScenarioConsolidationService = inject(ScenarioConsolidationService)) => {
      return this.actions$.pipe(

        ofType(ScenarioConsolidationActions.loadRiskHeatMap),
        mergeMap(({ scenarioId }) =>
          rs.getRiskHeatMap(scenarioId).pipe(
            map((riskHeatmap) => {
              return ScenarioConsolidationActions.loadRiskHeatMapSuccess({
                riskHeatmap
              });
            }),
            catchError((error) => of(ScenarioConsolidationActions.loadRiskHeatMapFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadLegalHeatMap$ = createEffect(
    (rs: ScenarioConsolidationService = inject(ScenarioConsolidationService)) => {
      return this.actions$.pipe(

        ofType(ScenarioConsolidationActions.loadLegalHeatMap),
        mergeMap(({ scenarioId, valueChain }) =>
          rs.getProcessHeatMap(scenarioId, valueChain).pipe(
            map((heatmap) => {
              return ScenarioConsolidationActions.loadLegalHeatMapSuccess({
                legalHeatmap: heatmap as HeatMapResults
              });
            }),
            catchError((error) => of(ScenarioConsolidationActions.loadLegalHeatMapFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  getScenarioLegalEntities$ = createEffect(
    (rs: ScenarioConsolidationService = inject(ScenarioConsolidationService)) => {
      return this.actions$.pipe(

        ofType(ScenarioConsolidationActions.getScenarioLegalEntities),
        mergeMap(({ scenarioId }) =>
          rs.getScenarioLegalEntities(scenarioId).pipe(
            map((legalEntities) => {
              return ScenarioConsolidationActions.getScenarioLegalEntitiesSuccess({
                legalEntities
              });
            }),
            catchError((error) => of(ScenarioConsolidationActions.getScenarioLegalEntitiesFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getScenarioHeatMaps$ = createEffect(
    (rs: ScenarioConsolidationService = inject(ScenarioConsolidationService)) => {
      return this.actions$.pipe(

        ofType(ScenarioConsolidationActions.loadScenarioHeatMaps),
        mergeMap(({ scenarioId, valueChain }) =>
          rs.getScenarioHeatmaps(scenarioId, valueChain).pipe(
            map((heatmaps) => {
              return ScenarioConsolidationActions.loadScenarioHeatMapsSuccess({
                heatmaps
              });
            }),
            catchError((error) => of(ScenarioConsolidationActions.loadScenarioHeatMapsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
